import React from "react";
import { DropDown, RadioContainer, RollingLoader } from "../../../commons";
import RecurringJobSetting, { selectStyle } from "./RecurringJobSetting";
import { COUNTRY_LABLE_VALUE } from "../../../../constant/countryCode";
import { JOB_TYPE_OPTIONS } from "../../../../constant/jobs";

type AppProps = {
  jobData: any;
  jobsError: any;
  handleChange: (data: any, name: string) => void;
  handleSubmit: () => void;
  history: any;
  fetching: boolean;
  type?: string;
  uniqueCheckMessage?: string;
  uniqueCheckFetching?: boolean;
  searchTerm?: any;
};

const AddEditJobCard = ({
  jobData,
  handleChange,
  jobsError,
  handleSubmit,
  history,
  type,
  fetching,
  uniqueCheckMessage,
  uniqueCheckFetching,
  searchTerm,
}: AppProps) => {
  return (
    <div>
      <div className="row">
        <div className="col-md-4">
          <form>
            <div className="form-group mt-3">
              <div>
                <label htmlFor="jobType">Job Type</label>
                <span className="color-red">*</span>
                <div className="d-flex flex-row position-relative">
                  <input
                    type="text"
                    className={`form-control`}
                    name="jobType"
                    value={jobData?.jobType}
                    onChange={(e) => {
                      handleChange(e, "jobType");
                    }}
                  />
                  {uniqueCheckFetching && jobData?.jobType && <RollingLoader />}
                </div>

                <div>
                  {!!jobsError?.jobType && (
                    <small className="text-danger">{jobsError?.jobType}</small>
                  )}
                </div>
                <span className="text-danger" style={{ fontSize: "12px" }}>
                  {jobData?.jobType?.length > 0 &&
                    uniqueCheckMessage?.includes("Job Type already exists") && (
                      <span>Job Type already exists</span>
                    )}
                </span>
              </div>
            </div>
          </form>
        </div>

        <div className="col-md-2">
          <form>
            <div className="form-group mt-3">
              <div>
                <label htmlFor="actionName">Short Code</label>
                <span className="color-red">*</span>
                <input
                  type="text"
                  className={`form-control`}
                  name="shortCode"
                  value={jobData?.shortCode}
                  onChange={(e) => handleChange(e, "shortCode")}
                />
                <div>
                  {!!jobsError?.shortCode && (
                    <small className="text-danger">
                      {jobsError?.shortCode}
                    </small>
                  )}
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>

      <div className="row">
        <div className="col-md-6">
          <form>
            <div className="form-group mt-3">
              <div>
                <label htmlFor="menuName">Job Details</label>
                <span className="color-red">*</span>
                <textarea
                  className="form-control"
                  name="jobDescription"
                  style={{ height: "115px", resize: "none" }}
                  onChange={(e) => handleChange(e, "jobDescription")}
                  value={jobData?.jobDescription}
                />
                <div>
                  {!!jobsError?.jobDescription && (
                    <small className="text-danger">
                      {jobsError?.jobDescription}
                    </small>
                  )}
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>

      <div className="row">
        <div className="col-md-4">
          <label className="form-group">Job Frequency</label>
          <RadioContainer
            optionsList={JOB_TYPE_OPTIONS}
            handleSetRadioValue={(e) => handleChange(e, "jobFrequency")}
            radioValue={jobData?.jobFrequency}
            alignment="horizontal"
          />
        </div>
      </div>

      {jobData?.jobFrequency === "RecurringJob" ? (
        <div>
          <RecurringJobSetting
            jobData={jobData}
            jobsError={jobsError}
            type={type}
            handleChange={handleChange}
          />
        </div>
      ) : null}

      <div className="row mt-3">
        <div className="col-md-4 ">
          <label>Country</label>
          <div className="mt-1">
            <DropDown
              options={COUNTRY_LABLE_VALUE}
              value={jobData?.country}
              handleChange={(e) => handleChange(e, "country")}
              style={selectStyle}
            />
          </div>
        </div>


        <div className="col-md-3">
              <div className="mt-1">
                <label htmlFor="actionName">Comment Threshold Days</label>
                <input
                  type="number"
                  className={`form-control`}
                  name="numberOfDaysToAddComment"
                  value={jobData?.numberOfDaysToAddComment}
                  onChange={(e) => handleChange(e, "numberOfDaysToAddComment")}
                />
              </div>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          gap: "10px",
          marginTop: "10%",
        }}
      >
        <button
          className="btn btn-outline"
          onClick={() =>
            history?.push({
              pathname: "/jobs/jobs-type",
              state: { searchTerm },
            })
          }
        >
          Cancel
        </button>
        <button
          className="btn btn-primary"
          disabled={
            fetching || uniqueCheckMessage?.includes("Job Type already exists")
          }
          onClick={handleSubmit}
        >
          {type == "editJob" ? "Save Changes" : "Save"}
        </button>
      </div>
    </div>
  );
};

export default AddEditJobCard;
